const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*?>/i;

function escapeHtml(text: string): string {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

/** Converts API plain text to HTML for the rich text editor. */
export function normalizeEmailHtml(content: string): string {
  if (!content?.trim()) return "<p></p>";
  if (HTML_TAG_PATTERN.test(content)) return content;

  return content
    .split(/\n\n+/)
    .map((paragraph) => {
      const lines = escapeHtml(paragraph).split("\n");
      return `<p>${lines.join("<br>")}</p>`;
    })
    .join("");
}

/** Ensures content is HTML before inserting into Outlook. */
export function prepareHtmlForOutlook(content: string): string {
  if (!content?.trim()) return "";
  if (HTML_TAG_PATTERN.test(content)) return content;
  return escapeHtml(content).replace(/\n/g, "<br>");
}

export function isEmptyEmailHtml(content: string): boolean {
  if (!content?.trim()) return true;
  const text = content
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .trim();
  return text.length === 0;
}
